import {PencilIcon} from '@time-webkit/all/icons';
import classNames from 'classnames';
import {forwardRef, useRef, useState} from 'react';

import {mergeRefs} from 'react-merge-refs';

import {useOnClickOutside} from 'usehooks-ts';

import styles from './styles.module.css';
import {TimeChipInput} from './time-chip-input';

export type TimeChipProps = {
    value: string;
    onChange: (time: string) => void;
    label?: string;
};

export const TimeChip = forwardRef<HTMLDivElement, TimeChipProps>(
    ({value, onChange, label}, externalRef) => {
        const innerRef = useRef(null);

        const [active, setActive] = useState(false);

        const [showTime, setShowTime] = useState(false);

        const wrapClass = classNames(styles.wrap, {
            [styles.active]: active,
            [styles.hover]: !active,
        });

        const handleBlur = () => {
            setActive(false);
        };

        const handleFocus = () => {
            setActive(true);
        };

        const handleClick = () => {
            if (value && showTime) {
                setShowTime(false);
            }
        };

        useOnClickOutside(innerRef, () => {
            if (value && !showTime) {
                setShowTime(true);
            }
        });

        return (
            <div
                ref={mergeRefs([innerRef, externalRef])}
                onBlur={handleBlur}
                onFocus={handleFocus}
                onClick={handleClick}
                className={wrapClass}
            >
                <PencilIcon width={16} height={16} />
                <TimeChipInput
                    onChange={onChange}
                    showTime={showTime}
                    value={value}
                    label={label}
                />
            </div>
        );
    },
);
